module.exports = __webpack_public_path__ + "static/media/slankamen2.bd75bf76.jpg";